import { useQuery } from '@tanstack/react-query'
import { findOneBatchImport } from '@/api'

const nonEmpty = (value: string | null | undefined): string | null =>
  (value ?? '').trim() || null

export const useBatchImportLabel = (
  batchImportId: string | null | undefined
) => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['batchimport', batchImportId],
    queryFn: () => findOneBatchImport(batchImportId ?? ''),
    enabled: Boolean(batchImportId),
    staleTime: 60_000,
  })

  const reference = nonEmpty(data?.referenceNabu)
  // Même ordre que le titre de la page déclaration, sans la référence Nabu,
  // affichée à part. `dataSetName` vaut '' pour un dossier créé sans nom.
  const name =
    nonEmpty(data?.metadata?.dataSetName) ??
    nonEmpty(data?.referenceClient) ??
    nonEmpty(data?.description)

  return { reference, name, isLoading, isError }
}
